import React from 'react'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
   passwordSuggestions: {
      color: 'red',
      fontSize: 12,
      margin: theme.spacing(0, 0, 2, 2),
      padding: theme.spacing(0, 2)
   }
}))

function PasswordRequirements() {
   const classes = useStyles()

   return (
      <ul className={classes.passwordSuggestions}>
         <li>Mínimo 8 caracteres.</li>
         <li>Mínimo una letra en mayúscula.</li>
         <li>Mínimo un caracter especial (!'#$%/=?¡*)</li>
         <li>Mínimo un número.</li>
         <li>No puede tener espacios.</li>
      </ul>
   )
}

export default PasswordRequirements
